import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations, contactInfo } from '../data/mock';
import { Phone, MapPin, Clock, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const footerText = t(translations.footer);
  const headerText = t(translations.header);

  return (
    <footer className="bg-[#0B1F3F] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center text-white font-bold">
                T
              </div>
              <div>
                <h3 className="font-bold">Tanuku Driving School</h3>
                <p className="text-xs text-gray-300">తణుకు డ్రైవింగ్ పాఠశాల</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 mb-4">{footerText.tagline}</p>
            <div className="flex items-center space-x-2 text-yellow-400">
              <span className="text-2xl font-bold">{contactInfo.rating}</span>
              <div>
                <div className="flex">{'⭐'.repeat(5)}</div>
                <p className="text-xs text-gray-300">{contactInfo.totalReviews} Reviews</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">{footerText.quickLinks}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.home}</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.about}</Link></li>
              <li><Link to="/courses" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.courses}</Link></li>
              <li><Link to="/why-us" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.whyUs}</Link></li>
              <li><Link to="/reviews" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.reviews}</Link></li>
              <li><Link to="/gallery" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.gallery}</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-[#FF6B35] transition-colors">{headerText.contact}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t(translations.contact).title}</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <Phone className="h-4 w-4 mr-2 mt-1 flex-shrink-0 text-[#FF6B35]" />
                <a href={`tel:${contactInfo.phone}`} className="text-gray-300 hover:text-[#FF6B35] transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-4 w-4 mr-2 mt-1 flex-shrink-0 text-[#FF6B35]" />
                <span className="text-gray-300">{contactInfo.address}</span>
              </li>
              <li className="flex items-start">
                <Clock className="h-4 w-4 mr-2 mt-1 flex-shrink-0 text-[#FF6B35]" />
                <span className="text-gray-300">{contactInfo.hours}</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-bold text-lg mb-4">{footerText.followUs}</h3>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-[#FF6B35] transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm text-gray-400">
          <p>{footerText.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
